import { ErrorMessage } from '@tunasong/tunasong-ui'

/**
 * The router's catch-all for an unknown route. `AdminGuard` renders the same element for a non-admin, so
 * `/app/admin` is indistinguishable from a route that doesn't exist (admin spec §3.4, Joni §6).
 */
export const notFoundElement = <ErrorMessage message="Page is not found" />
